import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ComingSoonPage: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center bg-gray-50 px-4">
            <div className="text-center max-w-lg">
                <div className="text-6xl mb-6">🚧</div>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    {t('common.comingSoon', 'Coming Soon')}
                </h1>
                <p className="text-lg text-gray-600 mb-8">
                    {t('common.featureComingSoonDesc', 'This feature is currently under development. Please check back later!')}
                </p>
                <div className="flex justify-center gap-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-100 transition font-medium text-gray-700"
                    >
                        {t('common.goBack', 'Go Back')}
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-medium"
                    >
                        {t('common.backToHome', 'Back to Home')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ComingSoonPage;
